import React, { PureComponent } from 'react';

import Button from 'widgets/Button';

import fpImage from 'themes/[theme]/assets/images/components/foodProfile/PU_fig.jpg'; // eslint-disable-line import/order

export default class FoodProfileStep1 extends PureComponent {
  render() {
    return (
      <div className="js-foodProfilePopup__step1">
          <div className="js-foodProfilePopup__headerBar">
              <h3>Food Profile</h3>
              <Button
                className="js-createFoodProfileClose"
                onClick={this.props.closeHandler}
              />
          </div>
          <img src={fpImage} alt="" />
          <p>
              We love giving you time back – that’s why you can now find food with
              your dietary needs in mind even faster. Less time spent scanning ingredients,
              more time spent enjoying your food.
          </p>
          <p>
              Follow the button below to personalise your Food Profile. Just select
              anything you’re allergic/intolerant to, or would compromise your dietary
              needs, and we’ll flag foods containing them as you browse Ocado.
          </p>
          <div className="js-foodProfilePopup__actionBar">
              <a href="https://www.foodmaestro.me/">Powered by Foodmaestro</a>
              <Button onClick={this.props.nextStepHandler}>Set up your food profile</Button>
          </div>
          <div className="gn-multiStepIndicator js-foodProfilePopup__stepIndicator">
              <span className="filled" />
              <span />
              <span />
          </div>
      </div>
    );
  }
}
